export default __webpack_public_path__ + "static/dtr-dbc103aa76402e1a332762efadd05da1.png";